// This file contains helpers functions for question export.

// Helper function to strip html tags from strings.
const strip = (html, newlineAfterParagraph = true) => {
    // convert p tags to newlines
    const paragraphReplacement = newlineAfterParagraph ? "\n" : ''
    html = html.replaceAll('<p>', '')
    html = html.replaceAll('</p>', paragraphReplacement)

    const tmpElement = document.createElement('template')
    tmpElement.innerHTML = html

    return tmpElement.content.textContent || ''
}

// Helper function to format an object to its containing text or image metadata.
const formatFieldAsText = (field) => {
    if (field.type === 'text' && field.text) {
        return field.text
    }

    return ''
}

export {strip, formatFieldAsText}
